"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchCheckoutConsignmentClickAndCollectAddressesPath = exports.searchCheckoutConsignmentClickAndCollectAddresses = void 0;
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
const searchCheckoutConsignmentClickAndCollectAddresses = (client) => async ({ checkoutId, consignmentId }) => {
    try {
        const response = await client.post((0, exports.searchCheckoutConsignmentClickAndCollectAddressesPath)(checkoutId, consignmentId));
        return utils_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            return utils_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.searchCheckoutConsignmentClickAndCollectAddresses = searchCheckoutConsignmentClickAndCollectAddresses;
const searchCheckoutConsignmentClickAndCollectAddressesPath = (checkoutId, consignmentId) => `/v2/bff/appro/checkouts/${checkoutId}/consignments/${consignmentId}/click-and-collect-addresses/search`;
exports.searchCheckoutConsignmentClickAndCollectAddressesPath = searchCheckoutConsignmentClickAndCollectAddressesPath;
